<template>
    <div class="bg-white p-3 radius-8 mt-3">
        <div class="row gy-4">

            <div
                class="col-lg-6 col-md-6"
                v-for="(column, colIndex) in splitIntoTwo(service.service_checkbox)"
                :key="'cb-col-' + colIndex"
            >
                <ul class="listItem">
                    <li v-for="(item, index) in column" :key="'cb-' + index">
                        <div class="form-check">
                            <label class="form-check-label" :for="item.checkbox_value">
                                {{ item.checkbox_value }}
                            </label>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :id="item.checkbox_value"
                                v-model="responses.checkboxes[item.checkbox_value]"
                            />
                        </div>
                    </li>
                </ul>
            </div>

            <!-- TEXT INPUT -->
            <div class="col-lg-6 col-md-6" v-for="(item, index) in service.service_input" :key="'in-' + index">
                <div class="form-group">
                    <label class="text-18">{{ item.input_value }}</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Enter Text"
                        v-model="responses.inputs[item.input_value]"
                    />
                </div>
            </div>

            <!-- DATE INPUT -->
            <div class="col-lg-6 col-md-6" v-for="(item, index) in service.service_date" :key="'date-' + index">
                <div class="form-group">
                    <label class="text-18">{{ item.date_value }}</label>
                    <input
                        type="date"
                        class="form-control"
                        v-model="responses.dates[item.date_value]"
                    />
                </div>
            </div>

        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    service: Object,
    responses: Object
})

const splitIntoTwo = (items) => {
    const midpoint = Math.ceil(items.length / 2);
    return [items.slice(0, midpoint), items.slice(midpoint)];
};
</script>
